import type {NormalizedCacheObject} from '@apollo/client';
import type {ApolloClientProxy} from '@igp/shared/api';
import {P2PPlayerSettingsService} from '@igp/shared/features/p2p-player-settings';
import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IMessageLocalizer} from '@igp/shared/localization';
import type {EntityType} from '@models';
import type {ResolutionContext} from 'inversify';

import {ServiceTypes} from '@ioc-container';

import {p2pPlayerSettingsServiceTypes} from './constants';

export class P2PPlayerSettingsContainerFacade extends ContainerFacade {
    bindAll() {
        this._container
            .bind<P2PPlayerSettingsService<EntityType>>(p2pPlayerSettingsServiceTypes.service)
            .toDynamicValue((context: ResolutionContext) => {
                return new P2PPlayerSettingsService(
                    context.get<ApolloClientProxy<NormalizedCacheObject>>(ServiceTypes.ApolloClientIGP),
                    context.get<IMessageLocalizer>(ServiceTypes.MessageLocalizer)
                );
            });
    }
}
